import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { LINK_CODE_CONFIG } from '@/lib/constants'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Generate a unique, non-guessable link code for caregiver profiles
 * Format: firstname-lastname-random (e.g., "sarah-j-12345")
 */
export function generateLinkCode(firstName: string, lastName: string): string {
  // Normalize names: lowercase, remove special characters, limit length
  const normalizeString = (str: string): string => {
    return str
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '')
      .substring(0, 10); // Limit length
  };

  const normalizedFirst = normalizeString(firstName);
  const normalizedLast = normalizeString(lastName);
  
  // Use first letter of last name if full last name is too long
  const lastPart = normalizedLast.length > 1 ? normalizedLast : normalizedLast.charAt(0);
  
  // Generate random suffix for uniqueness
  const randomSuffix = Math.floor(10000 + Math.random() * 90000);
  
  return `${normalizedFirst}${LINK_CODE_CONFIG.SEPARATOR}${lastPart}${LINK_CODE_CONFIG.SEPARATOR}${randomSuffix}`;
}

/**
 * Validate if a link code follows the expected format
 */
export function isValidLinkCode(linkCode: string): boolean {
  return LINK_CODE_CONFIG.PATTERN.test(linkCode);
}
